import { Link } from "react-router-dom";
import { useState } from "react";

import HeaderLanguageSelect from "./HeaderLanguageSelect";
import HeaderToggleMenuButton from "./HeaderToggleMenuButton";

const HeaderLoggedOut = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <header
      id="header"
      className="header-section2 header-section"
      onClick={(e) => {
        e.stopPropagation();
        if (isNavOpen) setIsNavOpen(false);
      }}
    >
      <nav className="navbar navbar-expand-lg position-relative py-md-3 py-lg-6 workready">
        <div
          className={`${isNavOpen ? "" : "collapse"} navbar-collapse justify-content-between`}
          id="navbar-content"
        >
          <ul className="navbar-nav2fixed navbar-nav d-flex align-items-lg-center gap-4 gap-sm-5 py-2 py-lg-0 align-self-center p2-bg">
            <li className="dropdown show-dropdown">
              <Link to="/market">
                Predictions<sup className="r1-color">HOT</sup>
              </Link>
            </li>
            <li className="dropdown show-dropdown">
              <Link to="/crypto">Crypto List</Link>
            </li>
            <li className="dropdown show-dropdown">
              <Link to="/">Guide</Link>
            </li>
            <li className="dropdown show-dropdown">
              <Link to="/promotions">Promotions</Link>
            </li>
            {/* <li className="dropdown show-dropdown">
                            <a href="ecricket.html">Promotions</a>
                        </li> */}
            {/* <li className="dropdown show-dropdown">
                            <a href="cycling.html">Racing</a>
                        </li> */}
            <li className="dropdown show-dropdown d-block d-sm-none">
              <div className="d-flex align-items-center flex-wrap gap-3">
                <Link
                  to="/login"
                  className="cmn-btn second-alt px-xxl-11 rounded-2"
                >
                  Log In
                </Link>
                <Link to="/register" className="cmn-btn px-xxl-11">
                  Sign Up
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <div className="right-area custom-pos position-relative d-flex gap-0 gap-lg-7 align-items-center me-5 me-xl-10">
          <HeaderLanguageSelect />
          <Link
            to="/login"
            className="cmn-btn second-alt px-xxl-11 rounded-2 me-5 me-lg-0 d-none d-sm-block"
          >
            Log In
          </Link>
          <Link
            to="/register"
            className="cmn-btn d-none px-xxl-11 d-sm-block d-lg-none d-xl-block"
          >
            Sign Up
          </Link>
        </div>
        <HeaderToggleMenuButton
          isNavOpen={isNavOpen}
          setIsNavOpen={setIsNavOpen}
          onClick={(e) => e.stopPropagation()}
        />
      </nav>
      <div id="div10" className="navigation left-nav-area box3 position-fixed">
        <div className="logo-area slide-toggle3 trader-list position-fixed top-0 d-flex align-items-center justify-content-center pt-6 pt-md-8 gap-sm-4 gap-md-5 gap-lg-7 px-4 px-lg-8">
          <i className="ti ti-menu-deep left-nav-icon n8-color order-2 order-lg-0 d-none">
            menu
          </i>
          <Link
            className="navbar-brand d-center text-center gap-1 gap-lg-2 ms-lg-4"
            to="/"
          >
            {/* <img className="logo" src="/assets/images/logo.png" alt="Logo" /> */}
            {/* <img className="logo d-none d-xl-block" src="/assets/images/logo-text.png" alt="Logo" /> */}
            <img
              className="logo"
              src="/assets/images/logo-full.png"
              alt="Logo"
            />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default HeaderLoggedOut;
